@use '../../../scss/utility/functions' as utility;

:host {
  display: block;
  --spacing: #{utility.wb-pixel-to-rem(16px)};
}

fieldset {
  all: unset;
  display: flex;
  flex-direction: column;
  gap: var(--spacing);
}

legend {
  position: absolute;
  pointer-events: none;
  opacity: 0;
}
